import { AspectRatioBox } from '@smartgift/frontend-toolkit';
import range from 'lodash/range';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  height: 100%;
  width: 100%;
`;

const Branding = () => (
  <AspectRatioBox ratio="1:1">
    <StyledContentLoader viewBox="0 0 100% 100%">
      <rect x="6" y="6" rx="6" ry="6" width="calc(100% - 12px)" height="calc(100% - 12px)" />
    </StyledContentLoader>
  </AspectRatioBox>
);

export function BrandingLoader({ count = 12 }) {
  return range(count).map(item => <Branding key={item} />);
}
